module.exports = __webpack_public_path__ + "static/turtle-creek-house37-922e6311b2b0de08f12f0f5c972e72cd.jpg";